import React from 'react';
import MyVisitHistory from '../personal-dashboard/my-visits/History/MyVisitHistory';
const SalesVisitHistoriesDashboard = () => {
  return <MyVisitHistory isFromManagerPage />;
};

SalesVisitHistoriesDashboard.propTypes = {};

export default SalesVisitHistoriesDashboard;
